import SettingPage from "../common/SettingPage";
import Header from "../Settings/Header";
import "../style/about.css";
import teamAvatar from "../assets/team-avatar.png";
import { __ } from "@wordpress/i18n";
import { ReactComponent as Facebook } from "../assets/fb-icon.svg";
import { ReactComponent as Instagram } from "../assets/insta-icon.svg";
import { ReactComponent as YouTube } from "../assets/youtube-icon.svg";
import { ReactComponent as Twitter } from "../assets/twitter-icon.svg";
import { ReactComponent as Checkmark } from "../assets/checkmark-dark.svg";
import { ReactComponent as Loader } from "../assets/loader.svg";
import LicenseNotice from "../common/LicenseNotice";
import WPForms from "../assets/plugins/plugin-wpforms.png";
import MonsterInsights from "../assets/plugins/plugin-mi.png";
import OptIn from "../assets/plugins/plugin-om.png";
import WPSMTP from "../assets/plugins/plugin-smtp.png";
import RafflePress from "../assets/plugins/plugin-rp.png";
import AIOSEO from "../assets/plugins/plugin-seo.png";
import PushEngage from "../assets/plugins/plugin-push.png";
import SeedProd from "../assets/plugins/plugin-seedprod.png";
import SocialWallBanner from "../assets/social-wall-graphic.png";

import { ajaxCall } from "../Helpers/AjaxHelper";
import { useState } from "react";
import { loadAsset } from "../Helpers/Utils";
import StickyWidget from "../StickyWidget";

const GetIcon = (slug) => {
  switch (slug) {
    case "facebook":
      return <Facebook />;
    case "instagram":
      return <Instagram />;
    case "youtube":
      return <YouTube />;
    case "twitter":
      return <Twitter />;
    case "wpforms":
      return WPForms;
    case "monsterinsights":
      return MonsterInsights;
    case "optinmonster":
      return OptIn;
    case "wp_mail_smtp":
      return WPSMTP;
    case "rafflepress":
      return RafflePress;
    case "aioseo":
      return AIOSEO;
    case "pushengage":
      return PushEngage;
    case "seedprod":
      return SeedProd;
  }
};

const PluginBox = ({ plugin, slug, noContainer, image }) => {
  const [isInstalling, setIsInstalling] = useState(false);
  const [isActivating, setIsActivating] = useState(false);

  const [isInstalled, setIsInstalled] = useState(plugin.installed);
  const [isActive, setIsActive] = useState(plugin.activated);
  const Container = ({ children }) => {
    if (noContainer) {
      return children;
    }
    return (
      <div className="sb-plugins-box">
        <div className="icon">
          {!image ? GetIcon(slug) : <img src={image} alt={slug} />}
        </div>
        {children}
      </div>
    );
  };

  return (
    <Container>
      <div className="plugin-box-content">
        <h4 className="sb-box-title">{plugin.title}</h4>
        <p className="sb-box-description">{plugin.description}</p>
        <div className="sb-action-buttons">
          {!isInstalled && (
            <button
              disabled={!plugin.download_plugin}
              className={`sby-btn sb-btn-add ${
                !plugin.download_plugin ? "sb-btn-installed" : ""
              }`}
              onClick={() => {
                setIsInstalling(true);
                ajaxCall("sby_install_addon", {
                  plugin: plugin.download_plugin,
                  type: "plugin",
                })
                  .then(() => {
                    setIsInstalled(true);
                    setIsActive(true);
                  })
                  .finally(() => {
                    setIsInstalling(false);
                  });
              }}
            >
              {isInstalling && (
                <span className="loading">
                  <Loader />
                </span>
              )}
              {__("Install", "feeds-for-youtube")}
            </button>
          )}
          {isInstalled && (
            <button className="sby-btn sb-btn-installed">
              <span>
                <Checkmark />
              </span>
              {__("Installed", "feeds-for-youtube")}
            </button>
          )}
          {isInstalled && !isActive && (
            <button
              onClick={() => {
                setIsActivating(true);
                ajaxCall("sby_activate_addon", {
                  plugin: plugin.plugin,
                  type: "plugin",
                })
                  .then(() => {
                    setIsInstalled(true);
                    setIsActive(true);
                  })
                  .finally(() => {
                    setIsInstalling(false);
                  });
              }}
              className="sby-btn sb-btn-activate"
            >
              {isActivating && (
                <span className="loading">
                  <Loader />
                </span>
              )}
              {__("Activate", "feeds-for-youtube")}
            </button>
          )}
        </div>
      </div>
    </Container>
  );
};
const AboutUs = () => {
  const { plugins, social_wall, recommendedPlugins } =
    window.sby_settings.pluginInfo;

  return (
    <div>
      {window.sby_settings.shouldShowPostGracePeriodNotice ? (
        <LicenseNotice />
      ) : null}
      <Header title="About Us" />
      <SettingPage
        subContainer={true}
        title={__("About Us", "feeds-for-youtube")}
        headerClassName="sby-settings-header sby-about-header pt-2"
      >
        <div className="sby-sb-container sby-no-margin">
          <div className="sby-about-box">
            <div className="sb-team-avatar">
              <img
                src={loadAsset(teamAvatar)}
                alt={__("Smash Balloon Team", "feeds-for-youtube")}
              />
            </div>
            <div className="sb-team-info">
              <div className="sb-team-left">
                <h2>
                  {__(
                    "At Smash Balloon, we build software that helps you create beautiful responsive social media feeds for your website in minutes.",
                    "feeds-for-youtube"
                  )}
                </h2>
              </div>
              <div className="sb-team-right">
                <p>
                  {__(
                    "We're on a mission to make it super simple to add social media feeds in WordPress. No more complicated setup steps, ugly iframe widgets, or negative page speed scores.",
                    "feeds-for-youtube"
                  )}
                </p>
                <p>
                  {__(
                    "Our plugins aren't just easy to use, but completely customizable, reliable, and fast! Which is why over 1.6 million awesome users, just like you, choose to use them on their site.",
                    "feeds-for-youtube"
                  )}
                </p>
              </div>
            </div>
          </div>

          <div className="sby-section-second-header">
            <h3>
              {__("Our Other Social Media Feed Plugins", "feeds-for-youtube")}
            </h3>
            <p>
              {__(
                "We’re more than just an Instagram plugin! Check out our other plugins and add more content to your site.",
                "feeds-for-youtube"
              )}
            </p>
          </div>

          <div className="sby-plugins-boxes-container">
            {Object.keys(plugins).map((key) => {
              const plugin = plugins[key];
              return <PluginBox slug={key} plugin={plugin} />;
            })}

            <div className="sb-plugins-box sby-social-wall-plugin-box">
              <span className="sb-box-bg-image">
                <img src={loadAsset(SocialWallBanner)} />
              </span>
              <PluginBox
                noContainer={true}
                className="plugin-box-content"
                plugin={social_wall}
              />
            </div>
          </div>

          <div className="sby-section-second-header">
            <h3>{__("Plugins we recommend", "feeds-for-youtube")}</h3>
          </div>

          <div className="sby-plugins-boxes-container sb-recommended-plugins">
            {Object.keys(recommendedPlugins).map((key) => {
              const plugin = recommendedPlugins[key];
              return (
                <PluginBox
                  image={loadAsset(GetIcon(key))}
                  slug={key}
                  plugin={plugin}
                />
              );
            })}
          </div>
        </div>
      </SettingPage>
      <StickyWidget />
    </div>
  );
};

export default AboutUs;
